import type { TableColumns, TableTagMappings } from '@ohpen/enso-ui';

import type { FlagRow } from './interfaces';

/** The two states a flag can be in, so the filter offers both whatever the data holds. */
export const VALUE_LIST_NAME = 'configFlagValues';

export const flagColumns: TableColumns<FlagRow> = [
  {
    title: 'config.columns.flag',
    dataIndex: 'flag',
    key: 'flag',
    width: 340,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.value',
    dataIndex: 'value',
    key: 'value',
    width: 140,
    options: {
      format: { type: 'tag' },
      filter: 'select',
      listName: VALUE_LIST_NAME,
      sorter: true,
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
  {
    title: 'config.columns.description',
    dataIndex: 'description',
    key: 'description',
    width: 150,
    options: { filter: 'search' },
    render: (description?: string) => description ?? '-',
  },
];

export const getValueTagMappings = (): TableTagMappings => ({
  value: {
    on: { color: 'green' },
    off: { color: '' },
  },
});
